import script from "./TypeIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeIcon.vue?vue&type=script&setup=true&lang=js"

import "./TypeIcon.vue?vue&type=style&index=0&id=77dc0a54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77dc0a54"]])

export default __exports__